import { useSelector } from 'hooks';
import { Client } from 'types';

import { ExtendedDescriptions } from 'components';

const Billing = () => {
  const client = useSelector((state) => state.auth.client as Client);

  return (
    <ExtendedDescriptions
      items={[
        {
          label: 'common.name',
          value: `${client.firstName} ${client.lastName}`,
        },
        {
          label: 'common.email',
          value: client.email,
        },
      ]}
    />
  );
};

export default Billing;
